import { render, staticRenderFns } from "./dispense.vue?vue&type=template&id=bd2db676&scoped=true"
import script from "./dispense.vue?vue&type=script&lang=js"
export * from "./dispense.vue?vue&type=script&lang=js"
import style0 from "./dispense.vue?vue&type=style&index=0&id=bd2db676&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2db676",
  null
  
)

export default component.exports